import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { PublishedDesign } from "./components/PublishedDesign";
import { getSiteConfig } from "./api";
import { getCompanySlugFromPath } from "./public-path";
import { defaultSiteConfig } from "./site-config";
import "./styles.css";

async function bootstrap() {
  let siteConfig;
  try {
    siteConfig = await getSiteConfig();
  } catch (error) {
    if (getCompanySlugFromPath()) {
      document.getElementById("root")!.textContent =
        error instanceof Error ? error.message : "会社情報を取得できませんでした。";
      return;
    }
    siteConfig = defaultSiteConfig;
  }

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <PublishedDesign />
      <App siteConfig={siteConfig} />
    </StrictMode>,
  );
}

void bootstrap();
